import { ChevronRight, Home } from 'lucide-react'

import { cn } from '@/lib/cn'

export function Breadcrumbs({
  bucket,
  prefix,
  onNavigate,
}: {
  bucket: string
  prefix: string
  onNavigate: (prefix: string) => void
}) {
  const segments = prefix.split('/').filter(Boolean)

  return (
    <nav aria-label="Breadcrumb" className="flex min-w-0 items-center gap-1 text-sm">
      <button
        onClick={() => onNavigate('')}
        className={cn(
          'inline-flex items-center gap-1.5 rounded px-1.5 py-1 hover:bg-muted',
          segments.length === 0 && 'font-medium',
        )}
      >
        <Home className="h-3.5 w-3.5" />
        {bucket}
      </button>

      {segments.map((segment, index) => {
        const isLast = index === segments.length - 1
        const target = `${segments.slice(0, index + 1).join('/')}/`
        return (
          <span key={target} className="flex min-w-0 items-center gap-1">
            <ChevronRight className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
            <button
              onClick={() => onNavigate(target)}
              className={cn('truncate rounded px-1.5 py-1 hover:bg-muted', isLast && 'font-medium')}
              aria-current={isLast ? 'page' : undefined}
            >
              {segment}
            </button>
          </span>
        )
      })}
    </nav>
  )
}
